import {
  CONSENT_CATEGORIES,
  CONSENT_COOKIE_NAME,
  VERSION,
} from './constants.js';
import type { ConsentCategory } from './constants.js';
import { createConsentClient } from './client.js';
import { createConsentBlocker } from './blocker.js';
import type { ConsentBlocker } from './blocker.js';
import type {
  ConsentClientSnapshot,
  ConsentEventMap,
  ConsentInitOptions,
  ConsentInitResult,
  ConsentPreferenceInput,
  ConsentState,
} from './types.js';

const client = createConsentClient();
let blocker: ConsentBlocker | null = null;

export { CONSENT_CATEGORIES, CONSENT_COOKIE_NAME, VERSION };

export function init(options: ConsentInitOptions): Promise<ConsentInitResult> {
  try {
    if (!blocker) {
      blocker = createConsentBlocker({
        client,
        ...(options.allowInsecureLocalhost === undefined
          ? {}
          : { allowInsecureLocalhost: options.allowInsecureLocalhost }),
      });
    }
    if (!blocker.started) blocker.start();
  } catch (error) {
    return Promise.reject(error);
  }
  return client.init(options);
}

export function retry(): Promise<ConsentInitResult> {
  return client.retry();
}

export function getSnapshot(): ConsentClientSnapshot {
  return client.getSnapshot();
}

export function getState(): ConsentState | null {
  return client.getState();
}

export function has(category: ConsentCategory): boolean {
  return client.has(category);
}

export function acceptAll(): Promise<ConsentState> {
  return client.acceptAll();
}

export function rejectAll(): Promise<ConsentState> {
  return client.rejectAll();
}

export function setPreferences(
  preferences: ConsentPreferenceInput,
): Promise<ConsentState> {
  return client.setPreferences(preferences);
}

export function on<EventName extends keyof ConsentEventMap>(
  eventName: EventName,
  callback: (event: ConsentEventMap[EventName]) => void,
): () => void {
  return client.on(eventName, callback);
}
